import React from 'react';
import { Box, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import Skeleton from './Skeleton';

/**
 * MessageListItemSkeleton - Loading placeholder for message/conversation list items
 * 
 * Layout:
 * - Avatar (48x48)
 * - Name + preview text
 * - Timestamp + unread badge
 * 
 * Use this when loading messages or conversations list
 * 
 * @version 1.0.0 (Feb 2026)
 */

const MessageListItemSkeleton = () => {
  return (
    <ListItem
      sx={{
        borderBottom: 1,
        borderColor: 'grey.200',
        py: 2,
      }}
    >
      <ListItemAvatar>
        <Skeleton
          variant="circular"
          width={48}
          height={48}
          animation="wave"
        />
      </ListItemAvatar>

      <ListItemText
        primary={
          <Box display="flex" justifyContent="space-between" mb={0.5}>
            <Skeleton
              variant="text"
              width="40%"
              height={20}
              animation="wave"
            />
            <Skeleton
              variant="text"
              width={60}
              height={16}
              animation="wave"
            />
          </Box>
        }
        secondary={
          <Box>
            <Skeleton
              variant="text"
              width="80%"
              height={16}
              animation="wave"
              sx={{ mb: 0.5 }}
            />
            <Skeleton
              variant="text"
              width="60%"
              height={16}
              animation="wave"
            />
          </Box>
        }
      />
    </ListItem>
  );
};

export default MessageListItemSkeleton;
